import React from "react";

const ArticleDeleteModal = ({
  show,
  loading,
  onClose,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title text-danger">
                🗑️ Supprimer l’annonce
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                disabled={loading}
              />
            </div>

            <div className="modal-body">
              <p>
                Êtes-vous sûr de vouloir <strong>supprimer cette annonce</strong> ?
              </p>
              <p className="text-muted">
                Cette action archivera l’annonce et la rendra invisible.
              </p>
            </div>

            <div className="modal-footer">
              <button
                className="btn_delete_article"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? "Suppression..." : "Confirmer la suppression"}
              </button>
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ArticleDeleteModal;
